// load bootstrap, jquery, axios, etc.
require('./bootstrap')

// setup vue
window.Vue = require('vue')
import { createApp } from 'vue'

// Assessment Cycle single file components
require('./assessmentCycle')

// Training Roster
import TrainingRoster from './components/training_roster/TrainingRoster.vue'
const trainingRoster = Vue.createApp({})
trainingRoster.component('training-roster', TrainingRoster)
trainingRoster.mount('#training_roster')

// Assessment Section title Edit-In-Place
import EditInPlace from './components/edit_in_place/EditInPlace.vue'
const editInPlace = Vue.createApp({})
editInPlace.component('edit-in-place', EditInPlace)
editInPlace.mount('#edit_in_place')

// CCHCs Report (didn't end up using this, but components are still there, so leaving it)
// import CchsReport from './components/cchcs_report/CchcsReport.vue'
// const cchcsReport = Vue.createApp({})
// cchcsReport.component('cchcs-report', CchsReport)
// cchcsReport.mount('#cchcs_report')